/**
 * Inventory API
 * Enhanced with InventoryItem CRUD, bulk upload, and overview
 */

import { apiClient } from "./apiClient";

export const inventoryAPI = {
  // Legacy endpoints (backward compatibility)
  getInventory: (organizationId) =>
    apiClient.get(`/inventory/org/${organizationId}/`),

  computeInventory: (organizationId, payload) =>
    apiClient.post(`/inventory/org/${organizationId}/compute/`, payload),

  // Enhanced InventoryItem endpoints
  listItems: (organizationId, params = {}) =>
    apiClient.get(`/inventory/items/org/${organizationId}/`, { params }),

  getOverview: (organizationId, params = {}) =>
    apiClient.get(`/inventory/items/org/${organizationId}/overview/`, { params }),

  getItem: (organizationId, itemId) =>
    apiClient.get(`/inventory/items/org/${organizationId}/${itemId}/`),

  createItem: (organizationId, payload) =>
    apiClient.post(`/inventory/items/org/${organizationId}/create/`, payload),

  updateItem: (organizationId, itemId, payload) =>
    apiClient.patch(`/inventory/items/org/${organizationId}/${itemId}/`, payload),

  deleteItem: (organizationId, itemId) =>
    apiClient.delete(`/inventory/items/org/${organizationId}/${itemId}/`),

  bulkUpload: (organizationId, payload) =>
    apiClient.post(`/inventory/items/org/${organizationId}/bulk-upload/`, payload),

  downloadTemplate: (organizationId) =>
    apiClient.get(`/inventory/items/org/${organizationId}/template/`, {
      responseType: 'blob',
    }),

  exportItems: (organizationId, params = {}) =>
    apiClient.get(`/inventory/items/org/${organizationId}/export/`, {
      params,
      responseType: 'blob',
    }),
};
